module.exports = __webpack_public_path__ + "img/2026-challenge-header.4ff2f330.png";